import styled from 'styled-components';

export default styled.section`
  padding: 2rem ${props => props.theme.padding.inner} 0;

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    display: flex;
    flex-direction: column;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.post};
      flex-direction: row;
      justify-content: center;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
        transition-delay: 0.4s;
      }
    }

    .active& {
      opacity: 1;
    }

    a {
      margin: 0.5rem 0;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        margin: 0 0.5rem;
      }
    }
  }
`;
